<div class="attr-ratings">
  <div class="attr-ratings-top">
    <div class="attr-ratings-score">
      <div class="attr-score-number">{{ formattedRating }}</div>
      <div class="attr-star-row">
        <app-attr-icon *ngFor="let s of stars" [name]="starIcon(s.kind)" [size]="14" class="star"></app-attr-icon>
      </div>
      <div class="attr-score-count">{{ 'attractions.reviews' | translate:{ count: reviewCount || 0 } }}</div>
    </div>

    <div class="attr-histogram" *ngIf="histogramTotal > 0">
      <div class="attr-histogram-row" *ngFor="let row of histogramRows">
        <span class="attr-histogram-star">{{ row.star }}</span>
        <span class="attr-histogram-track">
          <span class="attr-histogram-fill" [style.width.%]="row.fraction * 100"></span>
        </span>
        <span class="attr-histogram-count">{{ row.count }}</span>
      </div>
    </div>
  </div>

  <div class="attr-ratings-footer" *ngIf="footer">
    <div class="attr-ratings-divider"></div>
    <div class="attr-ratings-sources">{{ footer }}</div>
  </div>
</div>
